import { CountryAddress } from "@/configs/jtTypes";
import newData from "@/assets/json/vn_new.json";

// "old": 3 cấp Tỉnh/Quận Huyện/Phường Xã (có mã JT), "new": 2 cấp Tỉnh/Phường Xã sau sáp nhập
export type AddressMode = "old" | "new";

export const newCountryAddresses = newData as unknown as CountryAddress[];

// Phường/xã danh mục cũ luôn kèm mã JT ở cuối, ví dụ "Phường Nghĩa Đô-024QCG01"
export const isOldArea = (area?: string): boolean => /-\S+$/.test(area || "");

export const formatZone = (province?: string, district?: string, area?: string): string => {
  if (!district && area && !isOldArea(area)) {
    return `${province || ""}/${area}`;
  }
  return `${province || ""}/${district || ""}/${area || ""}`;
};
